const urlHead = "https://backend.dakafacai.com/"

export default urlHead
